var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{on:{"click":_vm.onLogout}},[_c('v-list-item-icon',[_c('v-icon',[_vm._v("mdi-logout")])],1),_c('v-list-item-title',[_vm._v(" Logout ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }